var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconDeepLink(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 10,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5,
    stroke: "#6B6C83"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.879 4.293L.757 6.414l2.829 2.829L5.707 7.12M4.293 2.879L6.414.757l2.829 2.829L7.12 5.707M6.414 3.586L3.586 6.414"
  }))));
}
export default SvgIconDeepLink;